/**
 * Filter DevTools console by: [auth-debug]
 *
 * In development, logging is always enabled. For production builds, set either:
 * - NEXT_PUBLIC_AUTH_DEBUG=1 (client + server where inlined), or
 * - AUTH_DEBUG_LOG=1 (server-only, e.g. API routes)
 */

export function authDebugEnabled(): boolean {
  return (
    process.env.NODE_ENV === "development" ||
    process.env.NEXT_PUBLIC_AUTH_DEBUG === "1" ||
    process.env.AUTH_DEBUG_LOG === "1"
  );
}

export function authDebugLog(...args: unknown[]): void {
  if (!authDebugEnabled()) return;
  console.log("[auth-debug]", ...args);
}
